export class SchemaRegistrySchemaResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "schemaId",
            "baseName": "schemaId",
            "type": "number",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": ""
        },
        {
            "name": "format",
            "baseName": "format",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaText",
            "baseName": "schemaText",
            "type": "string",
            "format": ""
        },
        {
            "name": "inferredIcebergSchema",
            "baseName": "inferredIcebergSchema",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "references",
            "baseName": "references",
            "type": "Array<SchemaReference>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySchemaResponse.attributeTypeMap;
    }
    constructor() {
    }
}
